import React, { FC, useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Table } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'

import { TSelectOption } from 'shared/types'
import { GlobalProduct } from 'shared/__gql-types'

import { IProductList } from './ProductList.props'

import './ProductList.scss'

const ProductList: FC<IProductList> = ({ products, projects, labelsOptions }) => {
  const getLabel = useCallback(
    (id?: string) => labelsOptions.find((item: TSelectOption) => item.value === id),
    [labelsOptions]
  )
  const getProject = useCallback((id?: string) => projects.find((campaign) => campaign.id === id), [projects])

  const productsListRows: any = useMemo(
    () =>
      products.reduce((result: any, product: GlobalProduct) => {
        const productsData = product.locals?.length
          ? product.locals.map((local) => ({
            ...local,
            name: product.name,
            label: getLabel(local?.label_id ?? '')?.label,
            project_name: getProject(local?.campaign_id ?? '')?.name
          }))
          : [{ name: product.name }]

        return [...result, ...productsData]
      }, []),
    [products, getLabel, getProject]
  )

  const columns: ColumnsType<unknown>[] = [
    {
      dataIndex: 'name',
      key: 'name',
      title: 'Product Title',
      sortable: false,
      width: '45%',
      align: 'left'
    },
    {
      dataIndex: 'project_name',
      key: 'project_name',
      title: 'Assigned Projects',
      sortable: false,
      width: '35%',
      align: 'left',
      render: (value: any, data: any) => (
        <Link to={`/projects/${data.campaign_id}`} className="artist-product-table__link" key={data.campaign_id}>
          {value}
        </Link>
      )
    },
    {
      dataIndex: 'label',
      key: 'label',
      title: 'Zone',
      sortable: false,
      width: '20%',
      align: 'left'
    }
  ]

  return (
    <Table
      className="artist-product-table"
      columns={columns}
      tableLayout="fixed"
      data={productsListRows}
      pagination={false}
      condensed={true}
    />
  )
}

export default ProductList
